import React from "react";
import "./styles/CartCard.css";

const CartCard = ({ index, item, updateCartQuantity, onClick, products }) => {
    return (
        <div className="cart-card-container">
            {item.isCombo ? (
                <div className="cart-combo-grid">
                    {Array.isArray(item.Products) &&
                        item.Products.map((productName, i) => {
                            const product = products?.[productName]; // Ensure `products` exists
                            return (
                                <img
                                    key={i}
                                    src={product?.Img?.[0] || "/placeholder.jpg"}
                                    alt={product?.Name || "Unknown Product"}
                                    className="cart-image"
                                />
                            );
                        })}
                </div>
            ) : (
                <div className="cart-card">
                    <img src={item.Img?.[0] || "/placeholder.jpg"} alt={item.Name} className="cart-item-image" />
                </div>
            )}
            <div className="cart-card-content">
                <h3 onClick={onClick}>{item.Name}</h3>
                <div className="details">
                    <span>Rs. {item.Price}</span>
                </div>
                <div className="actions">
                    <button onClick={() => updateCartQuantity(item.Name, -1)}>
                        &#8722;
                    </button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateCartQuantity(item.Name, 1)}>
                        &#43;
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CartCard;
